
import Vue from 'vue';
import Component from 'vue-class-component';
import VideoPlayer from './videoPlayer.vue';
import { Getter, Action } from 'vuex-class';
import { Prop, Watch } from 'vue-property-decorator';
import { dateToString } from '@/nmb/util';

@Component({
  components: { VideoPlayer }
})
export default class Course extends Vue {
  @Prop() noSearch: boolean;
  @Prop() keyword: string;

  @Getter courseTypes: any;
  @Getter courseCategory: any;

  @Action('getCourseTypes') getCourseTypes: Function;
  @Action('getCourseCategory') getCourseCategory: Function;

  dateToString: Function = dateToString;
  courseType: string = '';
  searchKey: string = '';
  curPage: number = 1;
  pageSize: number = 10;

  mounted() {
    if (!!this.$route.query.type) {
      this.courseType =
        this.$route.query.type && (this.$route.query.type.toString() as string);
    }
    if (!!this.$route.query.coursekey) {
      this.searchKey = this.$route.query.coursekey as string;
    }
    this.getCourseTypes();
    this.handleSearch();
  }

  unique4(arr: any) {
    const newArr = [];
    for (let i = 0; i < arr.length; i++) {
      if (newArr.indexOf(arr[i]) === -1) {
        newArr.push(arr[i]);
      }
    }

    return newArr;
  }

  replaceWord(key: any, val: any) {
    const htmlStr = '<em>' + key + '</em>';
    const reg = new RegExp('(' + key + ')', 'gi');

    return val && val.replace(reg, htmlStr);
  }

  highlightKeyword(title: string) {
    const newSearchKey = this.searchKey;
    const engStrReg = /[a-zA-Z]+/gi;
    const zhStrReg = /[\u4e00-\u9fa5]/g;
    const numberStrReg = /[0-9]/g;
    let englishArr = newSearchKey.match(engStrReg) || [];
    englishArr = this.unique4(englishArr);
    let znArr = newSearchKey.match(zhStrReg) || [];
    znArr = this.unique4(znArr);
    let numberArr = newSearchKey.match(numberStrReg) || [];
    numberArr = this.unique4(numberArr);
    let newTitle = title;

    englishArr.forEach((item: any) => {
      newTitle = this.replaceWord(item, newTitle);
    });

    numberArr.forEach((item: any) => {
      newTitle = this.replaceWord(item, newTitle);
    });

    znArr.forEach((item: any) => {
      // 关键字作为正则
      newTitle = this.replaceWord(item, newTitle);
    });

    return newTitle;
  }

  handleSearch() {
    if (this.noSearch) {
      this.searchKey = this.keyword;
    }
    const params = {
      courseName: this.searchKey,
      typeId: this.courseType,
      page: this.curPage
    };
    this.getCourseCategory(params);
  }

  handleSizeChange(val: number) {
    this.pageSize = val;
    this.handleSearch();
  }

  handleCurrentChange(val: number) {
    this.curPage = val;
    this.handleSearch();
  }

  handleClick(row: any) {
    this.$router.push({
      path: '/course/review',
      query: {
        id: row.courseId,
        category: row.categoryId
      }
    });
  }

  formatTime(row: any) {
    if (row.hasOwnProperty('totalVideoTime')) {
      let secondTime = parseInt(row.totalVideoTime, 10); // 秒
      let minuteTime = 0; // 分
      let hourTime = 0; // 小时
      if (secondTime > 60) {
        // 如果秒数大于60，将秒数转换成整数
        // 获取分钟，除以60取整数，得到整数分钟
        minuteTime = Math.floor(secondTime / 60);
        // 获取秒数，秒数取佘，得到整数秒数
        secondTime = secondTime % 60;
        // 如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          // 获取小时，获取分钟除以60，得到整数小时
          hourTime = Math.floor(minuteTime / 60);
          // 获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = minuteTime % 60;
        }
      }
      function strTime(time: any) {
        return `${(time < 10 && '0') || ''}${time}`;
      }
      const result = `${strTime(hourTime)}:${strTime(minuteTime)}:${strTime(
        secondTime
      )}`;

      return result;
    }
  }
  formatCreateTime(row: any) {
    if (!!row.created_at) {
      // return this.dateToString(new Date(row.created_at), 'yyyy-MM-dd');
      return row.created_at.split(' ')[0];
    } else {
      return '无';
    }
  }
  getCellStyle(param: any) {
    if (param.columnIndex > 0) {
      return { 'text-align': 'center' };
    }
  }
  getHeaderStyle(param: any) {
    const style = {
      'text-align': 'left',
      'background-color': '#FBFCFE',
      'border-top': '1px solid #ebeef5',
      'padding': '2px 0'
    };
    if (param.columnIndex > 0) {
      style['text-align'] = 'center';
    }

    return style;
  }
}
